import type { PsHttpSSE } from '@/services/sse-ps-http/sse-ps-http';
import type { SpecificationStreamContent } from '../types/specification';

export interface SpecificationGenParagraphRequest {
    /** 任务ID */
    task_id: string;
    /** 内容类型 */
    content_type: string;
    /** 操作类型 */
    operate_type?: string;
}

export type SpecificationGenParagraphResponse = string;

export const SpecificationGenParagraphApi = Symbol.for('SpecificationGenParagraphApi');

export interface SpecificationGenParagraphApi {
    /**
     * 生成说明书正文段落
     * 会自动保存到任务中
     */
    genSpecificationParagraph(data: SpecificationGenParagraphRequest): PsHttpSSE<SpecificationStreamContent<SpecificationGenParagraphResponse>>;
}
